import { render, staticRenderFns } from "./ChangeManagerOSP.vue?vue&type=template&id=6fbfe39c&scoped=true"
import script from "./ChangeManagerOSP.vue?vue&type=script&lang=js"
export * from "./ChangeManagerOSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfe39c",
  null
  
)

export default component.exports